import request from "../base/request";

let host = "/app-publish/diagnostic";
const Apis = {
    getMonitorListData: host + '/checklist',//检测列表
    getStartMonitorData: host + '/startcheck',//开始检测
};
export const getMonitorListData = (body,callBack) => {
    request({url:Apis.getMonitorListData, body, callBack});
};
export const getStartMonitorData = (body,callBack) => {
    request({url:Apis.getStartMonitorData, body, callBack});
};